// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__VBtey","modal_title":"ModalWindow_modal_title__68lPO","modal_text":"ModalWindow_modal_text__qTg++"};